/*
 * Página principal del flujo de cotización.
 * Controla el avance entre pasos del proceso (formularios, confirmación, etc.)
 * según el estado global del slice `quote`.
 * Muestra componentes de carga, error o el formulario activo dependiendo del estado actual.
 * Gestiona errores y reinicios mediante acciones de Redux.
 */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Box } from "@mui/material";
import CustomStepper from "../components/ph/CustomStepper/CustomStepper";

import QuoteForm from "../features/quote/pages/QuoteForm";
import CoverageSelector from "../features/coverage/pages/CoverageSelector";
import ContractorForm from "../features/contractor/pages/ContractorForm"
import InsuranceForm from "../features/insurance/pages/InsuranceForm";

import { setStep } from "../features/quote/quoteSlice";

const steps = [
  "DATOS DEL AUTO",
  "COBERTURAS",
  "DATOS PERSONALES",
  "DATOS DE LA PÓLIZA"
];

const QuoteProcessPage = () => {
  const dispatch = useDispatch();
  const { step } = useSelector((state) => state.quote);

  const handleStepClick = (targetStep) => {
    dispatch(setStep(targetStep));
  };

  const renderContent = () => {

    switch (step) {
      case 1:
        return <QuoteForm />;
      case 2:
        return <CoverageSelector />
      case 3:
        return <ContractorForm />
      case 4:
        return <InsuranceForm />
      default:
        return <QuoteForm />;
    }
  };

  return (
    <Container maxWidth="md" sx={{ py:4,  px: { xs: 2, sm: 3 } }}>
      <Box sx={{ mb: 2 }}>
        <CustomStepper 
          steps={steps} 
          activeStep={step - 1}
          onStepClick={handleStepClick}
        />
      </Box>
      <Box>
        {renderContent()}
      </Box>
    </Container>
  );
};

export default QuoteProcessPage;